<template>
  <zul-modal
    id="otp-validation-modal"
    class="is-small"
    ref="modal"
    :title="isPinStep ? $t('verifyPhoneNumber.navigation.title') : $t('verifyPhoneNumber.navigation.title2')"
  >
    <div class="otp-validation-wrapper">
      <div v-if="!isLoading">
        <div v-if="isPinStep" class="pin-step">
          <p class="pin-step-message">{{ $t("verifyPhoneNumber.sms.title") }}</p>
          <p
            class="maskedNumber"
            v-html="maskedPhoneNumber || OTPPhoneNumber"
          ></p>
          <PINInput ref="pinRef" v-model="otpValue" @filled="handleSubmit" />
        </div>
        <div class="otp-content" v-if="!isPinStep">
          <div class="zul-input-wrapper">
            <zul-input
              name="phoneNumber"
              v-model="OTPPhoneNumber"
              :label="$t('global.form.dddCellphone.title')"
              @keyup.enter.native="handleSubmit"
              autocomplete="off"
              ref="cellPhoneNumber"
              mask="(##) #####-####"
            />
          </div>
          <p class="otp-warning">
            {{ $t("verifyPhoneNumber.disclaimer") }}
          </p>
        </div>
      </div>
      <div v-if="isLoading" class="loading-container">
        <div class="loader" />
      </div>
      <button
        v-if="!isLoading"
        class="button is-primary otp-confirm-button"
        :disabled="
          (!isPinStep && OTPPhoneNumber.replace(/\D/g, '').length !== 11) ||
          (isPinStep && otpValue.length !== 4)
        "
        @click.prevent="handleSubmit"
      >
        Continuar
      </button>
    </div>
  </zul-modal>
</template>

<script>
import { getIdentifierHeaders } from "@zuldigital/utils";
import PINInput from "../components/PINInput";

export default {
  name: "OTPValidationModal",
  components: {
    PINInput,
  },
  props: ["maskedPhoneNumber"],
  data() {
    return {
      isPinStep: false,
      loginOPTResponseError: {},
      isOTPModalVisible: false,
      OTPPhoneNumber: "",
      otpValue: "",
      isLoading: false,
    };
  },
  mounted() {
    this.$root.$on("open-otp-validation-modal", () => {
      this.$refs.modal.open();
    });

    this.$root.$on("close-otp-validation-modal", () => {
      this.$refs.modal.close();
    });
  },
  destroyed() {
    this.$root.$off("open-otp-validation-modal");
    this.$root.$off("close-otp-validation-modal");
  },
  methods: {
    requestOtp(phoneNumber) {
      const data = new FormData();

      if (phoneNumber) {
        data.append("phoneNumber", phoneNumber);
      }

      return this.$http.post("/user/request-otp", data, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });
    },
    close() {
      this.$emit("close");
    },
    checkStep(newMaskedPhoneNumberValue) {
      // eslint-disable-next-line no-console
      this.$nextTick(() => {
        if (this.$refs.pinRef) {
          this.$refs.pinRef.clear();
        }

        this.focusCellPhoneNumberInput();

        this.OTPPhoneNumber = "";
      });

      if (newMaskedPhoneNumberValue) {
        this.isLoading = true;

        this.requestOtp()
          .then(() => {
            this.isPinStep = true;
            this.isLoading = false;
          })
          .catch((error) => {
            const message =
              (((error || {}).response || {}).data || {}).message ||
              this.$t('global.error.message');

            this.$buefy.toast.open({
              message,
              type: "is-danger",
            });

            this.close();
            this.isLoading = false;
          });
      } else {
        this.isPinStep = false;
      }
    },
    focusCellPhoneNumberInput() {
      if (this.$refs.cellPhoneNumber) {
        this.$refs.cellPhoneNumber.$el.querySelector("input").focus();
      }
    },
    phoneNumberSubmit() {
      const phoneNumber = this.OTPPhoneNumber.replace(/\D/g, "");

      if (phoneNumber.length === 11) {
        this.isPinStep = true;
        this.isLoading = true;
        this.requestOtp(`+55${phoneNumber}`)
          .then(() => {
            this.isLoading = false;
          })
          .catch((error) => {
            const message =
              (((error || {}).response || {}).data || {}).message ||
              this.$t('global.error.message');

            this.$buefy.toast.open({
              message,
              type: "is-danger",
            });

            this.isPinStep = false;
            this.isLoading = false;
          });
      } else {
        // showError
      }
    },
    doLogin() {
      this.isLoading = true;

      const formattedPhoneNumber = this.OTPPhoneNumber.replace(/\D/g, "");
      const data = new FormData();

      data.append("otp", this.otpValue);

      if (formattedPhoneNumber) {
        data.append("phoneNumber", formattedPhoneNumber);
      }

      this.$auth.login({
        data,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          ...getIdentifierHeaders(),
        },
        success() {
          this.isLoading = false;
        },
        error(error) {
          const status = ((error || {}).response || {}).status;
          let message = "";

          switch (status) {
            case 406:
              message = this.$t('global.otpError.406');
              break;

            default:
              message = this.$t('global.otpError.message');
              break;
          }

          this.$buefy.toast.open({
            message,
            type: "is-danger",
          });

          this.isLoading = false;
        },
      });
    },
    handleSubmit() {
      if (!this.isPinStep) {
        this.phoneNumberSubmit();
      } else {
        this.doLogin();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.loader {
  width: 60px;
  height: 60px;
}

.otp-validation-wrapper {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  width: 100%;
}

.pin-step-message {
  color: #b5b5b5 !important;
  margin-bottom: 20px;
}

.otp-confirm-button {
  width: 100%;
}

.otp-warning {
  margin-top: 30px;
  color: #b5b5b5 !important;
}

.otp-content {
  display: flex;
  flex-direction: column;
  align-items: center;

  > .control {
    width: 90%;

    > input {
      background-color: transparent;
      box-shadow: none;
      outline: none;
      border: none;
      color: #fff;
      border-radius: 0;
      padding: 0;

      &::placeholder {
        color: #fff;
      }
    }
  }

  > p {
    text-align: center;
    width: 90%;
  }
}

.pin-step {
  width: 100%;
  margin: 0 auto;
  text-align: center;

  .maskedNumber {
    font-size: 21px;
    font-weight: 700;
    margin-bottom: 10px;
  }
}

.loading-container {
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
<style lang="scss">
@import "../assets/sass/variables";

.otp-validation-wrapper {
  .zul-input-wrapper {
    background-color: transparent;
    border-bottom: 1px solid $primarySAO;

    label {
      padding-left: 0 !important;
    }

    > div {
      background-color: transparent;
    }

    input {
      padding-left: 0 !important;
      border-bottom: 0;
    }
  }
}
</style>
